import classNames from 'classnames';

export const buttonClasses = classNames(
  'whitespace-nowrap',
  'font-medium',
  'rounded-full',
  'bg-green-yellow',
  'border-black',
  'border-2',
  'transition',
  'shadow-5px',
  'hover:shadow-none',
  'hover:translate-x-[-5px]',
  'hover:translate-y-[5px]',
  'font-bold',

  // Small screen
  'px-6',
  'py-2',
  'text-sm',

  // Large screen
  'md:px-8',
  'md:py-3',
  'md:text-xl',
);
